import React from "react";

import withBrand from "@/components/with-brand";

import Styles from "./text-selection-button.module.css";
import LabelButtonWrapper from "../button-wrapper/button-wrapper";

type TextSelectionButtonProps = {
  id?: string | number;
  label: string;
  className?: string;
  onClick?: () => void;
  onBlur?: () => void;
  brand?: "staysure" | "avanti";
  isDisabled?: boolean;
};

function TextSelectionButton({
  id = "default",
  label,
  className,
  onClick,
  onBlur,
  brand = "staysure",
  isDisabled = false,
}: Readonly<TextSelectionButtonProps>) {
  return (
    <LabelButtonWrapper
      id={`text-selection-button-${id}`}
      hierarchy="tertiary"
      label={label}
      className={`${brand} ${Styles.textSelectionButton} ${className} !rounded-[0px] disabled:cursor-not-allowed`}
      onClick={onClick}
      onBlur={onBlur}
      isDisabled={isDisabled}
    />
  );
}

export default withBrand(TextSelectionButton);
